import CampaignContent from "Components/campaigns/insights/CampaignContent"
import CampaignPerformance from "Components/campaigns/insights/CampaignPerformance"
import CollaborationsTable from "Components/campaigns/insights/CollaborationsTable"
import OverallCollaboration from "Components/campaigns/insights/OverallCollaboration"
import SocialPerformance from "Components/campaigns/insights/SocialPerformance"
import { PRIVILEGE } from "constants/privilege"
import withAccessControl from "hoc/withAccessControl"
import useDocumentTitle from "hooks/useDocumentTitle"
import CampaignLayout from "Layouts/CampaignLayout"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import { DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink, UncontrolledDropdown } from "reactstrap"
import { updateCollaborationTableFilters } from "slices/campaigns/collaborations/reducer"
import { fetchCampaignInsights } from "slices/campaigns/insights/thunk"
import { fetchCampaignPerformance } from "slices/campaigns/performance/thunk"
import { setCampaignPostsFilters } from "slices/campaigns/posts/reducer"
import { AppDispatch, RootState } from "store"
import { SortOptionLabel, SortOptions } from "types/campaign/collaborations"
import { CampaignPostsFilters } from "types/campaign/posts"
import { PostTypeOptionLabel, PostTypeOptions, SortOptionLabel as PostSortOptionLabel, SortOptions as PostSortOptions } from "types/campaign/posts"

const CampaignInsights = () => {

    useDocumentTitle("Insights - Campaign");

    const [activeTab, setActiveTab] = useState<string>('creators');
    const dispatch: AppDispatch = useDispatch();
    const { campaignId } = useParams();
    const { tableFilters } = useSelector((state: RootState) => state.collaborations);
    const { filters: contentFilters } = useSelector((state: RootState) => state.campaignPosts.posts);

    useEffect(() => {
        if (campaignId) {
            dispatch(fetchCampaignInsights({ campaignId }));
            dispatch(fetchCampaignPerformance({ campaignId }));
        }
    }, [dispatch, campaignId])

    const updateSorting = (sortOption: SortOptions) => {
        let updated_filters = { ...tableFilters, sort: sortOption };
        delete updated_filters.order;
        if ([SortOptions.LOWEST_CPE, SortOptions.LOWEST_CPV].includes(sortOption)) {
            updated_filters.order = 'asc';
        }
        dispatch(updateCollaborationTableFilters(updated_filters));
    }

    const setCongentFilters = (updatedFilters: CampaignPostsFilters) => {
        dispatch(setCampaignPostsFilters(updatedFilters));
    }

    return (
        <CampaignLayout
        // filters={<button className="theme-btn btn-primary"><i className='bx bxs-report me-1' ></i>Download Report</button>}
        >
            <div className="row d-flex">
                <div className="col-lg-4">
                    <div className="d-flex flex-column">
                        <OverallCollaboration />
                        <SocialPerformance />
                    </div>
                </div>
                <div className="col-lg-8 mt-4 mt-lg-0">
                    <div className="card h-100">
                        <CampaignPerformance />
                    </div>
                </div>
            </div>
            <div className="row mt-4">
                <div className="col-12">
                    <div className="card campaign-insights-card">
                        <div className="card-header d-flex justify-content-between align-items p-4 border-0 flex-column flex-lg-row gap-2 gap-lg-0">
                            <Nav tabs className="nav nav-tabs nav-tabs-custom nav-primary nav-justified campaign-nav w-100 w-lg-50">
                                <NavItem className='campaign-nav-item'>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={`campaign-nav-link ${activeTab === 'creators' && 'active-campaign-nav'} text-start`}
                                        onClick={() => setActiveTab('creators')}
                                    >
                                        Creators
                                    </NavLink>
                                </NavItem>
                                <NavItem className='campaign-nav-item'>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={`campaign-nav-link ${activeTab === 'content' && 'active-campaign-nav'} text-start`}
                                        onClick={() => setActiveTab('content')}
                                    >
                                        Content
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            {
                                activeTab === 'creators' &&
                                <>
                                    <UncontrolledDropdown className='sort-dropdown me-2'>
                                        <DropdownToggle tag={"button"} className='btn btn-white d-flex justify-content-between align-items-center w-100'>
                                            <span>
                                                <span className='text-muted me-1'>Sort by: </span>
                                                {SortOptionLabel[tableFilters.sort]}
                                            </span>
                                            <i className='mdi mdi-chevron-down' />
                                        </DropdownToggle>
                                        <DropdownMenu className='mt-1 p-0 w-100'>
                                            {
                                                Object.values(SortOptions).map((sortOption, i) => <DropdownItem key={i} onClick={() => updateSorting(sortOption)}>
                                                    {SortOptionLabel[sortOption]}
                                                </DropdownItem>
                                                )
                                            }
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </>
                            }
                            {
                                activeTab === 'content' &&
                                <div className="d-flex align-items-center gap-2 justify-content-end">
                                    <UncontrolledDropdown className='sort-dropdown'>
                                        <DropdownToggle tag={"button"} className='btn btn-white d-flex justify-content-between align-items-center w-100'>
                                            <span>
                                                <span className='text-muted me-1'>Post Type: </span>
                                                {
                                                    (!contentFilters.type || contentFilters.type === PostTypeOptions.ALL) ? PostTypeOptionLabel[PostTypeOptions.ALL] : PostTypeOptionLabel[contentFilters.type as keyof typeof PostTypeOptionLabel]
                                                }
                                            </span>
                                            <i className='mdi mdi-chevron-down fs-5' />
                                        </DropdownToggle>
                                        <DropdownMenu className='mt-1 p-0 w-100'>
                                            {
                                                Object.values(PostTypeOptions).map((postTypeOption, i) => <DropdownItem key={i} onClick={() => setCongentFilters({ ...contentFilters, ...(postTypeOption === PostTypeOptions.ALL ? { type: null } : { type: postTypeOption }) })}>{PostTypeOptionLabel[postTypeOption]}</DropdownItem>)
                                            }
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                    <UncontrolledDropdown className='sort-dropdown'>
                                        <DropdownToggle tag={"button"} className='btn btn-white d-flex justify-content-between align-items-center w-100'>
                                            <span>
                                                <span className='text-muted me-1'>Sort by: </span>
                                                {PostSortOptionLabel[contentFilters.sort as keyof typeof PostSortOptionLabel]}
                                            </span>
                                            <i className='mdi mdi-chevron-down fs-5' />
                                        </DropdownToggle>
                                        <DropdownMenu className='mt-1 p-0 w-100'>
                                            {
                                                Object.values(PostSortOptions).map((sortOption, i) => <DropdownItem key={i} onClick={() => setCongentFilters({ ...contentFilters, sort: sortOption })}>{PostSortOptionLabel[sortOption]}</DropdownItem>)
                                            }
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </div>
                            }
                        </div>
                        <div className="card-body p-0 m-0">
                            {
                                activeTab === 'creators' && <CollaborationsTable />
                            }
                            {
                                activeTab === 'content' && <CampaignContent />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </CampaignLayout>
    )
}

export default withAccessControl(CampaignInsights, PRIVILEGE.CAMPAIGN.PERFORMANCE.INDEX)